import { render, staticRenderFns } from "./DocRequestSetup.vue?vue&type=template&id=d9a17e48"
import script from "./DocRequestSetup.vue?vue&type=script&lang=js"
export * from "./DocRequestSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports